import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  projects: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainProjects: [],
};

// TODO: fetch all the projects
export const fetchProjects = createAsyncThunk(
  "fetchProjects/projects",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`projects`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create project
export const createProject = createAsyncThunk(
  "createProject/projects",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`projects`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update project
export const updateProject = createAsyncThunk(
  "updateProject/projects",
  async ({image, data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`projects/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        image
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete project
export const deleteProject = createAsyncThunk(
  "deleteProject/projects",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`projects/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const projectslice = createSlice({
  name: "project",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get project
    builder.addCase(fetchProjects.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchProjects.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.projects = action.payload;
      state.mainProjects = state.projects?.data?.filter?.(
        (cat) => cat?.parent_id === null
      );
    });

    builder.addCase(fetchProjects.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create project
    builder.addCase(createProject.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createProject.fulfilled, (state, action) => {
      state.isLoading = false;
      state.projects.data = [action.payload.data, ...state.projects.data];
      state.projects.meta.total = state.projects.meta.total + 1;
      action.payload.enqueueSnackbar("Project is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createProject.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update project
    builder.addCase(updateProject.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateProject.fulfilled, (state, action) => {
      state.isLoading = false;
      if(!action.payload.image){
        state.projects.data = state.projects.data.map((project) => {
          if (project.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return project;
          }
        });
      }
      // action.payload.image &&  window.location.reload()
      action.payload.enqueueSnackbar("Project is updated successfully.", {
        variant: "success",
      });

      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateProject.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete project
    builder.addCase(deleteProject.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteProject.fulfilled, (state, action) => {
      state.isLoading = false;
      state.projects.data = state.projects.data.filter(
        (project) => project.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Project is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteProject.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default projectslice.reducer;

export const { resetLoadings } = projectslice.actions;
